import { render, staticRenderFns } from "./RegistrarUsuario.vue?vue&type=template&id=535bc02e"
import script from "./RegistrarUsuario.vue?vue&type=script&lang=js"
export * from "./RegistrarUsuario.vue?vue&type=script&lang=js"
import style0 from "./RegistrarUsuario.vue?vue&type=style&index=0&id=535bc02e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports